import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpParams } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import {Router} from "@angular/router"
import {OwlCarousel} from 'ngx-owl-carousel';
import { NgxSpinnerService } from 'ngx-spinner';
import { NgxSmartModalService } from 'ngx-smart-modal';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-all-content',
  templateUrl: './all-content.component.html',
  styleUrls: ['./all-content.component.scss']
})
export class AllContentComponent implements OnInit {
  constructor(public ngxSmartModalService: NgxSmartModalService, private spinner: NgxSpinnerService, public http: HttpClient, private router: Router) {this.ping()}
  allChannels: any = [];
  isHeadStart = environment.isHeadStart;
    renderStatic = environment.renderStatic;
  numbers: any = [];
  siteID = environment.siteID;
  singleChannel = environment['singleChannel'];
  singleChannelMultiPlay =  environment['singleChannelMultiPlay'];
  singleChannelID = '';
  validateChan = false;
  contents: any;
  contentVideos: any;
  contentsSearch = [];
  playlists = [];
  content: any;
  channels:any;
  channelsSearch:any;
  loaded:boolean = false;
  channelLoaded:boolean = false;
  videosLoaded:boolean = false;
  playlist: any;
  playlistsSearch: any;
  isWoohoo: boolean = environment['isWooHoo'];;
  sliderOptions = { dots: false, navigation: true, nav: true, navText : ['<i class="fa fa-angle-left" aria-hidden="true"></i>','<i class="fa fa-angle-right" aria-hidden="true"></i>'], autoplay: false, loop: true, autoplayTimeout: 2000, autoplayHoverPause: true,  lazyLoad: true, responsive:{ 0:{ items: 3 }, 600:{ items: 5 }, 960:{ items: 5 }, 1200:{ items: 5 } } };
  config = {slidesPerView: 'auto',autoHeight: true, navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  }, loop: false,
  breakpoints: {
    // when window width is <= 320px
    320: {
      slidesPerView: 'auto',
      spaceBetween: 0
    },
    // when window width is <= 480px
    480: {
      slidesPerView: 'auto',
      spaceBetween: 0
    },
    // when window width is <= 720px
    720: {
      slidesPerView: 'auto',
      spaceBetween: 0
    },
    // when window width is <= 720px
    1000: {
      slidesPerView: 'auto',
      spaceBetween: 0
    }
  }
};
public ping() {
  const myheader = new HttpHeaders().set('Content-Type', 'application/form-data');
      let body = new HttpParams();
      let callURL = 'https://api-staging.videyo.tv/endpoint/getChannelsForSite?siteID='+this.siteID
      if(this.renderStatic) {
        callURL = 'https://json.videyo.tv//'+this.siteID+'/getChannelsForSite/fullData.json?salt='+(new Date().toISOString().slice(0,13))
      }
       this.http.get(callURL, {
     headers: myheader
      })
  .subscribe(
    dataholder => {
      let data = dataholder
      if(this.renderStatic) {
       data = dataholder['data']
      }
      this.numbers = Array(5).fill(0).map((x,i)=>i);
       this.allChannels = data;
       this.validateChan = true;
       this.singleChannelID = this.allChannels['channel']['0']['id'];
       if(this.singleChannel == true) { 
         this.getVideos()
       }
       if(this.singleChannelMultiPlay == true) { 
        this.getPlaylists()
      }
       
    },
    error => {
      if (error.status >= 400 && error.status < 500) { 
        this.ngxSmartModalService.create('myModal1', '').open();
      }
      else if (error.status >= 500) { 
        this.ngxSmartModalService.create('myModal2', '').open();
        
      }
      console.log('ERROR:');
      console.log(error);
    }
);
}
getPlaylists() { 
  let Playlistkey = 'playlist';
  this.playlists = JSON.parse(localStorage.getItem(Playlistkey));
  if (this.playlists) {
    this.videosLoaded = true;
  }
    this.videosLoaded = false;
    const myheader = new HttpHeaders().set('Content-Type', 'application/form-data');
    let body = new HttpParams();
    this.http.get('https://api-staging.videyo.tv/endpoint/getChannel?siteID='+this.siteID+'&depth=2&channelID=' + this.singleChannelID, {
      headers: myheader
    })
      .subscribe(
        data => {
          this.playlists = data['playlists'];
          let playlistObj = this.playlists;
            localStorage.setItem(Playlistkey, JSON.stringify(playlistObj));
          this.videosLoaded = true;
        },
        error => {
          if (error.status >= 400 && error.status < 500) { 
            this.ngxSmartModalService.create('subscribe', '').open();
          }
          else if (error.status >= 500) { 
            this.ngxSmartModalService.create('myModal2', '').open();
            
          }
          console.log('ERROR:');
          console.log(error);
        }
      );
}
getVideos() { 
  let key = 'VideoList';
    this.contents = JSON.parse(localStorage.getItem(key));
    console.log(this.contents);
    if (this.contents) {
      this.videosLoaded = true;
    }
    const myheader = new HttpHeaders().set('Content-Type', 'application/form-data');
    let body = new HttpParams();
    this.http.get('https://api-staging.videyo.tv/endpoint/getChannel?siteID='+this.siteID+'&depth=4&channelID=' + this.singleChannelID, {
      headers: myheader
    })
      .subscribe(
        data => {
          this.contents = [];
          this.playlists = data['playlists'];
          this.playlists.forEach(playlist => {
            playlist.contents.forEach(content => {
              this.contents.push(content);
            });
            let myObj = this.contents;
            localStorage.setItem(key, JSON.stringify(myObj));

          });
          this.videosLoaded = true;
        },
        error => {
          if (error.status >= 400 && error.status < 500) { 
            this.ngxSmartModalService.create('subscribe', '').open();
          }
          else if (error.status >= 500) { 
            this.ngxSmartModalService.create('myModal2', '').open();
            
          }
          console.log('ERROR:');
          console.log(error);
        }
      );
}
  ngOnInit() {
    /** spinner starts on init */
    this.spinner.show();
 
    setTimeout(() => {
        /** spinner ends after 5 seconds */
        this.spinner.hide();
    }, 5000);
  }
  
}